import { Flame, Leaf, Mountain, Wind } from 'lucide-react';
import type { ElementType } from '../types';

const elementIcons = {
  FIRE: Flame,
  WIND: Wind,
  FOREST: Leaf,
  MOUNTAIN: Mountain,
} as const;

export function ElementIcon({ element, size = 'md' }: { element: ElementType; size?: 'sm' | 'md' | 'lg' }) {
  const Icon = elementIcons[element];
  return <span className={`element-icon element-icon--${element.toLowerCase()} element-icon--${size}`} aria-hidden="true">
    <Icon strokeWidth={2.35} />
  </span>;
}
